import { FilterValueType } from "../enums/filter-value-type";

export class FilterValue {

    value: string
    type: FilterValueType

    constructor(value: string, type: FilterValueType) {
        this.value = value;
        this.type = type;
    }

    filterLabel(): string {
        switch (this.type) {
            case FilterValueType.status: return 'Status: ' + this.value;
            case FilterValueType.entryDate: return 'Eingangsdatum: ' + this.value;
            case FilterValueType.burialDate: return 'Einäscherungsdatum: ' + this.value;
            case FilterValueType.startDate: return 'Von: ' + this.value;
            case FilterValueType.endDate: return 'Bis: ' + this.value;
            case FilterValueType.invoiceNumber: return 'Belegnummer: ' + this.value;
        }
    }

}
